import type React from 'react';

import type { EventMatchingDescriptorDescriptorType } from '@vlabs/api/luna-api/model/EventMatchingDescriptorDescriptorType';
import type { FaceId } from '@vlabs/api/luna-api/model/FaceId';
import type { Similarity } from '@vlabs/api/luna-api/model/Similarity';

import { EventMatchCard } from './cards/EventMatchCard';
import { FaceMatchCard } from './cards/FaceMatchCard';
import { PersonMatchCard } from './cards/PersonMatchCard';

type EventCardProps =
  | {
    type?: 'event';
    eventId: string;
    matcherType?: EventMatchingDescriptorDescriptorType;
    similarity?: Similarity;
  }
  | {
    type: 'face';
    faceId: FaceId;
    similarity?: Similarity;
  }
  | {
    type: 'person';
    externalId: string;
    similarity?: Similarity;
  };

function EventCard(props: EventCardProps): React.JSX.Element | null {
  if ('faceId' in props) {
    const { faceId, similarity } = props;
    return (
      <FaceMatchCard
        faceId={faceId}
        similarity={similarity}
      />
    );
  }

  if ('externalId' in props) {
    const { externalId, similarity } = props;
    return (
      <PersonMatchCard
        externalId={externalId}
        similarity={similarity}
      />
    );
  }

  if ('eventId' in props) {
    const { eventId, matcherType = 'face', similarity } = props;
    return (
      <EventMatchCard
        eventId={eventId}
        matcherType={matcherType}
        similarity={similarity}
      />
    );
  }

  return null;
}

export { EventCard };
